module.exports = __webpack_public_path__ + "static/media/bowls.a2629892.jpg";